import { render } from "./OcAttachDelete.vue?vue&type=template&id=618090f5&scoped=true"
import script from "./OcAttachDelete.vue?vue&type=script&lang=js"
export * from "./OcAttachDelete.vue?vue&type=script&lang=js"

import "./OcAttachDelete.vue?vue&type=style&index=0&id=618090f5&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618090f5"]])

export default __exports__